"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// document file types
exports.default = {
    JPG: 'jpg',
    PNG: 'png',
    JPEG: 'jpeg',
};
